// @flow
import React from 'react';

import Text from '@waglabs/text';

type Props = {};

export const WagTagDescription = (props: Props) => (
  <Text
    fontFamily="bodyMuli"
    {...props}
  >
    {'Wag! Tag is a smarter dog tag that gives anyone who finds your lost pet access to their unique online profile, with info to help with a safe and speedy return.'}
  </Text>
);
